
const state = {
    info_box_message: {
        show: false,
        isWarn: false,
        displayText: '',
        timer: 0
    }
}

const mutations = {
    infoBoxVisibility(state, val) {

        state.info_box_message = val; 
    }
}

const getters = {
    infoBoxMessage: function (state) {

        return state.info_box_message;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations
}